import React, { useState } from "react";

//Importar helpers.
import { getMessageHistory } from "../../../../helpers/fetch";
import useTimeDifferenceInMinutes from "../../../../hooks/useTimeDifferenceInMinutes";
import { getClassBasedOnTime } from "../../../../helpers/getClassBasedOnTime";

//Importar componentes locales.
import MessageTimeInInbox from "./MessageTimeInInbox";
import MessageByTypeInInbox from "./MessageByTypeInInbox";
import OperatorUserAvatar from "../../../common/Avatar/OperatorUserAvatar";
import { FILTER_VALUE_FINALIZADOS } from "../../../../const/filtersValue/filterValue";

//  ChatInInbox: Componente que renderiza el chat entrante que se concatena en el Inbox.  

const ChatInInbox = ({ chat, idChat, onSelectedChat, idChatSeleccionado, filterValue }) => {

    // LLamar a la función para traer los chats.
    const handleClick = async (idChat) => getMessages(idChat);

    // Estado para almacenar la diferencia de tiempo entre el mensaje entrante y la hora actual
    const [timeDifference, setTimeDifference] = useState(0); 

    let CLASS_PRIORITY_BY_TIME = (filterValue === FILTER_VALUE_FINALIZADOS) ? "finished-message" : getClassBasedOnTime(timeDifference); //Establecer las prioridades de los mensajes.

    const getMessages = async (idChat) => {    //Función para traer el historial del mensaje.
        console.log('id del chat seleccionado', idChat);
        let messageHistory = await getMessageHistory(idChat);            
        onSelectedChat(messageHistory, idChat); //Invocar a la función de callback en ListChat.
    };
    
    useTimeDifferenceInMinutes({ chat, timeDifference, setTimeDifference });

    return (
        <div className={`card-message__inbox ${CLASS_PRIORITY_BY_TIME} ${idChat === idChatSeleccionado ? 'active' : ''}`} 
        onClick={() => handleClick(idChat)}>

            {/*---Renderiza el ávatar del operador----*/}
            <OperatorUserAvatar iniciales={chat.Iniciales} priorityByTime={CLASS_PRIORITY_BY_TIME}/>

            {/*---Renderiza el tipo del mensaje y el nombre del chat----*/}
            <MessageByTypeInInbox type={chat.Type} chat={chat} idChat={idChat} 
            idChatSeleccionado={idChatSeleccionado}/>
            
            {/*---Renderiza la hora de llegada del mensaje----*/}
            <MessageTimeInInbox chat={chat} setTimeDifference={setTimeDifference} />

        </div>
    )
};

export default ChatInInbox;